
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import {
    IconRearrange, IconLocked,
    TemplateIconDocument, TemplateIconImage, TemplateIconMultipleChoice, TemplateIconText, TemplateIconVideo, TemplateIconAudio,
} from '../../../icons/svgs';

function SlideItemElement({selectedSlideIndex, index, slide, handleClick, id}) {

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({
        id: id,
        aaa: 'bbb',
        transition: null
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    const templateIcons = {
        document: <TemplateIconDocument />,
        image: <TemplateIconImage />,
        multiplechoice: <TemplateIconMultipleChoice />,
        text: <TemplateIconText />,
        video: <TemplateIconVideo />,
        audio: <TemplateIconAudio />
    };

    return (
        <div
            className={`tbcourse-sidebar-items cursor-pointer` + (selectedSlideIndex === index ? ' selected' : '') + (!slide.template.canRearrange() ? ' locked' : '')}
            data-id={slide.id}
            ref={setNodeRef}
            style={style}
            {...(slide.template.canRearrange() ? attributes : {})}
            {...(slide.template.canRearrange() ? listeners : {})}
        >
            <div
                className="tbcourse-sidebar-items-content"
                onClick={() => handleClick(index)}
            >
                {slide.template.canRearrange() ? (
                    <div
                        className="tbcourse-sidebar-items-reorder"
                    >
                        <IconRearrange />
                    </div>
                ) : (
                    <div
                        className="tbcourse-sidebar-items-reorder"
                    >
                        <IconLocked />
                    </div>
                )}
                <span className="tbcourse-sidebar-items-icon">
                    {templateIcons[slide.template.iconType()]}
                </span>
                <div className="tbcourse-sidebar-items-name text-ellipsis" title={slide.name}>
                    {slide.name}
                </div>
            </div>
        </div>
    );
}

export default SlideItemElement;